import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { useCurrentCulture } from '@/utils/hooks';
import { setUserLocale } from '@/services/users';
import { SupportedCultures } from '@/utils/localization';
import NavigationContextMenu from '../NavigationContextMenu';

interface HeaderLanguageMenuProps {}

const HeaderLanguageMenu: React.FC<HeaderLanguageMenuProps> = (props) => {
    const user = useSelector((state: IState) => state.global.user);
    const [, setCurrentCulture] = useCurrentCulture();

    const changeLocale = (locale: string) => {
        const actualCulture = setCurrentCulture(locale);

        if (user && user.isLoggedIn && actualCulture.locale !== user?.locale) {
            setUserLocale(actualCulture.locale);
        }
    };

    return (
        <>
            {SupportedCultures.map((culture) => (
                <NavigationContextMenu.Button
                    key={culture.locale}
                    title={culture.localName}
                    onClick={() => changeLocale(culture.locale)}
                />
                // <button key={culture.locale} dir="auto" onClick={() => changeLocale(culture.locale)}>
                //     {culture.localName}
                // </button>
            ))}
        </>
    );
};

export default HeaderLanguageMenu;
